import { Component, OnInit } from "@angular/core";
import { Route } from "./Route";
import { SidebarService } from "./sidebar.service";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
  version = "4.5.0";
  navigationRoutes!: Route[];

  constructor(private sidebarService: SidebarService) {}

  get openedRoute() {
    return this.sidebarService.openedRoute;
  }

  ngOnInit(): void {
    this.sidebarService.onNavigationRoutesLoaded.subscribe(
      (navigationRoutes) => {
        this.navigationRoutes = navigationRoutes;
      },
    );
  }

  onNavigationClick(route: Route) {
    this.sidebarService.changeNavigation(route);
  }

  getRouteIconClass(level: number): string | null {
    if (level === 1) {
      return "sidebarLevel1Icon";
    }
    if (level >= 2) {
      return "sidebarLevel2Icon";
    }
    return null;
  }
}
